// src/components/auth/CadastroPacienteBox.jsx
import React, { useRef, useState, useEffect } from "react";
import Style from "../../styles/components/auth/Entrada.module.scss";
import Loader from "../../design/components/Loader/Loader";
import { FiCalendar, FiCheck, FiMail, FiPhone, FiUser } from "react-icons/fi";
import { AiOutlineArrowLeft } from "react-icons/ai";
import LogoEscuroDois from "../../Assets/images/logo/escuroGrad.svg";
import PagePoliticas from '../../pages/politicas/PagePoliticas'
import Offcanvas from "../common/SwipeableOffcanvas.jsx";
import { getFunctions, httpsCallable } from "firebase/functions";

const CadastroPacienteBox = ({ formData, handleInputChange, handlePreviousStep, setSessionId, setHint, setStep, setMensagemSistema, setVerifyPayload, erros = {} }) => {
  const celularRef = useRef(null);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [erroAceiteTermos, setErroAceiteTermos] = useState(false);
  const [localErrors, setLocalErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const functions = getFunctions(undefined, "southamerica-east1");

  const [telefoneJaExiste, setTelefoneJaExiste] = useState(false);
  const [telefoneChecado, setTelefoneChecado] = useState(false);
  const checkPhoneExistsFn = httpsCallable(functions, "checkPhoneExists");


  useEffect(() => {
    const savedAffiliateData = localStorage.getItem('affiliateData');
    if (savedAffiliateData) {
      try {
        const affiliateData = JSON.parse(savedAffiliateData);
        handleInputChange({
          target: {
            name: 'MULTIPLE_FIELDS',
            value: {
              AFFILIATE_PARTNER_ID: affiliateData.AFFILIATE_PARTNER_ID,
              AFFILIATE_CODE: affiliateData.AFFILIATE_CODE,
              AFFILIATE_ORIGIN: affiliateData.AFFILIATE_ORIGIN,
              AFFILIATE_CAPTURED_AT: affiliateData.AFFILIATE_CAPTURED_AT,
            },
          },
        });
      } catch (error) {
        console.error("Erro ao processar dados de afiliado do localStorage:", error);
      }
    }
  }, []);

  useEffect(() => {
    const savedGymRef = localStorage.getItem("LESVITA_GYM_REF");
    if (!savedGymRef) return;

    try {
      const gymRef = JSON.parse(savedGymRef);

      // Vínculo de equipe (aditivo): capturado junto do gymRef. A inscrição de
      // fato acontece pós-OTP em VerificacaoCode (applyGymReferralToUser.teamCode);
      // aqui só garantimos que o código fica disponível no formData.
      let teamJoinCode = null;
      try {
        const teamJoin = JSON.parse(localStorage.getItem("LESVITA_TEAM_JOIN") || "null");
        teamJoinCode = teamJoin?.teamCode || null;
      } catch (_e) { /* ignore */ }

      handleInputChange({
        target: {
          name: "MULTIPLE_FIELDS",
          value: {
            GYM_REFERRAL_CODE: gymRef.referralCode,
            GYM_REFERRAL_CAPTURED_AT: gymRef.capturedAt,
            GYM_REFERRAL_ORIGIN: gymRef.origin || "GYM",
            GYM_TEAM_JOIN_CODE: teamJoinCode,
          },
        },
      });
    } catch (err) {
      console.error("Erro ao ler LESVITA_GYM_REF:", err);
    }
  }, []);



  const handleCadastroSubmit = async () => {
    const novoErros = {};
    setLocalErrors({});
    setErroAceiteTermos(false);

    const nome = formData.NOME || formData.nome;
    const sobrenome = formData.SOBRENOME || formData.sobrenome;
    const email = formData.EMAIL || formData.email;
    const ddd = (formData.DDD || "").replace(/\D/g, "");
    const celular = (formData.CELULAR || "").replace(/\D/g, "");
    const data = formData.DATA_NASC || formData.nascimento;
    const cpf = (formData.CPF || "").replace(/\D/g, "");

    if (!nome) novoErros.NOME = "Preencha o nome.";
    if (!sobrenome) novoErros.SOBRENOME = "Preencha o sobrenome.";
    if (!email || !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email))
      novoErros.EMAIL = "Preencha o email corretamente.";
    if (!ddd || ddd.length !== 2) novoErros.DDD = "DDD inválido.";
    if (!celular || celular.length !== 9)
      novoErros.CELULAR = "Preencha o celular corretamente.";
    if (!data || data.length !== 10) {
      novoErros.DATA_NASC = "Preencha a data corretamente.";
    } else {
      // Validação de idade mínima (16 anos — exigido pelo termo de dados sensíveis)
      const [dd, mm, yyyy] = data.split("/");
      const nascimento = new Date(`${yyyy}-${mm}-${dd}`);
      const hoje = new Date();
      const idadeMs = hoje - nascimento;
      const anos = idadeMs / (1000 * 60 * 60 * 24 * 365.25);
      if (anos < 16) {
        novoErros.DATA_NASC = "É necessário ter pelo menos 16 anos para se cadastrar.";
      }
    }
    // validações específicas PROFISSIONAL (se usar aqui)
    if (formData.ROLE === "PROFISSIONAL") {
      const sexoVal = formData.SEXO;
      const formacaoVal = formData.FORMACAO;

      if (!sexoVal) novoErros.SEXO = "Selecione o sexo.";
      if (!formacaoVal) novoErros.FORMACAO = "Selecione sua profissão.";

      if (!formData.CRM_CRN || formData.CRM_CRN.trim().length < 5) {
        novoErros.CRM_CRN = "Preencha o CRM ou CRN corretamente.";
      }
    }

    if (!formData.aceiteTermos) {
      setErroAceiteTermos(true);
      novoErros.aceiteTermos =
        "É necessário aceitar os Termos de Uso e a Política de Privacidade.";
    }

    // se o blur já descobriu que o telefone existe, marca o erro aqui
    if (telefoneChecado && telefoneJaExiste) {
      novoErros.CELULAR =
        "Este celular já está cadastrado. Faça login ou use outro número.";
    }

    // Se ainda não checou o telefone, checa agora no submit
    if (!telefoneChecado && !novoErros.CELULAR && ddd && celular.length === 9) {
      try {
        const res = await checkPhoneExistsFn({ ddd, celular });
        const exists = res?.data?.exists;
        if (exists) {
          novoErros.CELULAR =
            "Este celular já está cadastrado. Faça login ou use outro número.";
          setTelefoneJaExiste(true);
        }
        setTelefoneChecado(true);
      } catch (error) {
        console.error("Erro ao checar telefone no submit:", error);
      }
    }

    // se tiver qualquer erro -> não segue
    if (Object.keys(novoErros).length > 0) {
      setLocalErrors(novoErros);
      return;
    }

    setLoading(true);

    // pega do padrão certo
    let gymRef = null;
    try {
      gymRef = JSON.parse(localStorage.getItem("LESVITA_GYM_REF") || "null");
    } catch (e) {
      gymRef = null;
    }

    const formDataToSend = {
      ...formData,
      GYM_REFERRAL_CODE: formData.GYM_REFERRAL_CODE || gymRef?.referralCode || null,
      GYM_REFERRAL_CAPTURED_AT: formData.GYM_REFERRAL_CAPTURED_AT || gymRef?.capturedAt || null,
      GYM_REFERRAL_ORIGIN: formData.GYM_REFERRAL_ORIGIN || gymRef?.origin || "GYM",
      PARTNER_USER: formData.PARTNER_USER === true || gymRef?.partnerUser === true,
      // Checkbox ÚNICO (lançamento web): o consentimento de dados sensíveis
      // (LGPD Art. 11) agora é seção integrante dos Termos/Política v3.0 — o
      // aceite único cobre os dois registros (mesma trilha de auditoria).
      aceiteDadosSensiveis: formData.aceiteTermos === true,
    };

    try {
      const startVerification = httpsCallable(functions, "startVerification");

      const payload = {
        mode: "cadastro",
        cpf,
        formData: formDataToSend,
      };

      const result = await startVerification(payload);
      const dataResp = result.data || {};

      if (dataResp.status === "sent") {
        // Guarda o payload para permitir o reenvio do código a partir da tela OTP.
        if (setVerifyPayload) setVerifyPayload(payload);
        setSessionId(dataResp.sessionId);
        setHint(dataResp.hint);
        setStep(3);
      } else {
        console.error("Erro retornado pela função:", dataResp.status);
        setMensagemSistema("Erro ao iniciar cadastro.");
      }
    } catch (error) {
      console.error("Erro ao iniciar verificação de cadastro:", error);
      setMensagemSistema("Erro ao iniciar cadastro.");
    } finally {
      setLoading(false);
    }
  };


  const handleCustomChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    if (name === "DDD") {
      newValue = value.replace(/\D/g, "").slice(0, 2);
      setTelefoneChecado(false);
      setTelefoneJaExiste(false);
      if (newValue.length === 2) celularRef.current?.focus();
    }

    if (name === "CELULAR") {
      newValue = value.replace(/\D/g, "");
      newValue = newValue.replace(/(\d{5})(\d)/, "$1-$2");
      setTelefoneChecado(false);
      setTelefoneJaExiste(false);
    }

    if (name === "DATA_NASC") {
      newValue = value.replace(/\D/g, "");
      if (newValue.length >= 5) newValue = newValue.replace(/(\d{2})(\d{2})(\d{1,4})/, "$1/$2/$3");
      else if (newValue.length >= 3) newValue = newValue.replace(/(\d{2})(\d{1,2})/, "$1/$2");
    }

    handleInputChange({ target: { name, value: newValue } });
  };

  const handleCelularBlur = async () => {
    const dddDigits = (formData.DDD || "").replace(/\D/g, "");
    const celDigits = (formData.CELULAR || "").replace(/\D/g, "");

    // só chama o backend se tiver DDD e celular completos
    if (dddDigits.length !== 2 || celDigits.length !== 9) return;

    try {
      const res = await checkPhoneExistsFn({
        ddd: dddDigits,
        celular: celDigits,
      });
      const exists = res?.data?.exists;
      setTelefoneJaExiste(!!exists);
      setTelefoneChecado(true);
    } catch (error) {
      console.error("Erro ao verificar telefone:", error);
    }
  };

  // Campos como LISTA CONTÍNUA (§ 2 do prompt): cada um é uma linha com
  // rótulo em caps, valor 17px e ícone azul à direita, separados por
  // divisor — sem caixas. Os `name`, os handlers e as validações são
  // exatamente os que já existiam.
  const linha = (rotulo, campo) => (
    <div className={Style.linha} key={rotulo}>
      <span className={Style.linhaRotulo}>{rotulo}</span>
      {campo}
    </div>
  );

  return (
    <div className={Style.tela}>
      <span className={Style.fundoInterno} aria-hidden="true" />

      <div className={Style.topo}>
        <div className={Style.topoLinha}>
          <button type="button" className={Style.voltarTexto} onClick={handlePreviousStep}>
            <AiOutlineArrowLeft size={18} />
            voltar
          </button>
          <span className={Style.passo}>2 / 2</span>
        </div>
        <h1 className={Style.tituloGrande}>Criar conta</h1>
      </div>

      <div className={Style.lista}>
        {linha('NOME', (
          <>
            <div className={Style.linhaCampo}>
              <input
                className={Style.linhaEntrada}
                type="text"
                name="NOME"
                value={formData.NOME || ""}
                onChange={handleInputChange}
                placeholder="Como te chamam"
                autoComplete="given-name"
              />
              <FiUser size={16} className={Style.linhaIcone} />
            </div>
            {erros.NOME && <span className={Style.linhaErro}>{erros.NOME}</span>}
          </>
        ))}

        {linha('SOBRENOME', (
          <>
            <div className={Style.linhaCampo}>
              <input
                className={Style.linhaEntrada}
                type="text"
                name="SOBRENOME"
                value={formData.SOBRENOME || ""}
                onChange={handleInputChange}
                placeholder="Seu sobrenome"
                autoComplete="family-name"
              />
              <FiUser size={16} className={Style.linhaIcone} />
            </div>
            {erros.SOBRENOME && <span className={Style.linhaErro}>{erros.SOBRENOME}</span>}
          </>
        ))}

        {linha('DATA DE NASCIMENTO', (
          <>
            <div className={Style.linhaCampo}>
              <input
                className={Style.linhaEntrada}
                type="tel"
                name="DATA_NASC"
                maxLength="10"
                value={formData.DATA_NASC || ""}
                onChange={handleCustomChange}
                placeholder="DD/MM/AAAA"
                inputMode="numeric"
              />
              <FiCalendar size={16} className={Style.linhaIcone} />
            </div>
            {(erros.DATA_NASC || localErrors.DATA_NASC) && (
              <span className={Style.linhaErro}>
                {localErrors.DATA_NASC ?? erros.DATA_NASC}
              </span>
            )}
          </>
        ))}

        {linha('E-MAIL', (
          <>
            <div className={Style.linhaCampo}>
              <input
                className={Style.linhaEntrada}
                type="email"
                name="EMAIL"
                value={formData.EMAIL || ""}
                onChange={handleInputChange}
                placeholder="voce@email.com"
                autoComplete="email"
                inputMode="email"
              />
              <FiMail size={16} className={Style.linhaIcone} />
            </div>
            {erros.EMAIL && <span className={Style.linhaErro}>{erros.EMAIL}</span>}
          </>
        ))}

        {linha('CELULAR', (
          <>
            <div className={Style.linhaCampo}>
              <input
                className={Style.linhaDdd}
                type="tel"
                name="DDD"
                maxLength="2"
                value={formData.DDD || ""}
                onChange={handleCustomChange}
                placeholder="DDD"
                inputMode="numeric"
                aria-label="DDD"
              />
              <input
                className={Style.linhaEntrada}
                type="tel"
                name="CELULAR"
                ref={celularRef}
                value={formData.CELULAR || ""}
                onChange={handleCustomChange}
                onBlur={handleCelularBlur}
                placeholder="90000-0000"
                inputMode="numeric"
                autoComplete="tel-national"
              />
              <FiPhone size={16} className={Style.linhaIcone} />
            </div>
            {(erros.DDD || erros.CELULAR || localErrors.CELULAR) && (
              <span className={Style.linhaErro}>
                {erros.DDD || localErrors.CELULAR || erros.CELULAR}
              </span>
            )}
          </>
        ))}

        {/* Aceite LGPD: checkbox quadrado de raio 7, azul quando marcado. */}
        <div className={Style.aceite}>
          <button
            type="button"
            className={`${Style.caixa} ${formData.aceiteTermos ? Style.caixaMarcada : ""}`}
            onClick={() =>
              handleInputChange({
                target: { name: "aceiteTermos", value: !formData.aceiteTermos },
              })
            }
            role="checkbox"
            aria-checked={!!formData.aceiteTermos}
            aria-label="Aceito os Termos de Uso e a Política de Privacidade"
          >
            {formData.aceiteTermos && <FiCheck size={13} />}
          </button>
          <span className={Style.aceiteTexto}>
            Aceito os{" "}
            <button type="button" className={Style.aceiteLink} onClick={() => setShowOffcanvas(true)}>
              Termos de Uso
            </button>{" "}
            e a{" "}
            <button type="button" className={Style.aceiteLink} onClick={() => setShowOffcanvas(true)}>
              Política de Privacidade
            </button>{" "}
            da LesVita, incluindo o tratamento de dados de saúde (LGPD Art. 11).
          </span>
        </div>

        {erroAceiteTermos && (
          <p className={Style.erro}>
            É necessário aceitar os Termos de Uso e a Política de Privacidade.
          </p>
        )}
      </div>

      <div className={Style.base}>
        <button
          type="button"
          className={Style.primario}
          onClick={handleCadastroSubmit}
          disabled={loading || !formData.aceiteTermos}
        >
          {loading ? <Loader tamanho={28} /> : 'Cadastrar'}
        </button>
      </div>

          {/* Offcanvas — Termos de Uso e Política de Privacidade */}
          <Offcanvas className={Style.containerOffcanvasPolitica} show={showOffcanvas} onHide={() => setShowOffcanvas(false)} placement="end">
            <Offcanvas.Header closeButton className={Style.headerOffcanvasPolitica}>
            </Offcanvas.Header>
            <Offcanvas.Body className={Style.bodyOffcanvasPolitica}>
              <PagePoliticas />
            </Offcanvas.Body>
          </Offcanvas>

      <div id="recaptcha-container" style={{ display: "none" }}></div>
    </div>
  );
};

export default CadastroPacienteBox;